import { render, staticRenderFns } from "./ApuracaoFornecedorArquivo.vue?vue&type=template&id=2c51262c&scoped=true"
import script from "./ApuracaoFornecedorArquivo.vue?vue&type=script&lang=js"
export * from "./ApuracaoFornecedorArquivo.vue?vue&type=script&lang=js"
import style0 from "./ApuracaoFornecedorArquivo.vue?vue&type=style&index=0&id=2c51262c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c51262c",
  null
  
)

export default component.exports